import { getLoggedInUser, getAuthToken, fetchCheckoutLink, getAppRuntimeConstants, updateDownloadLinksWithVersion, logUserActivity } from './utils'

const checkoutSuccessUrl = 'https://musesessions.co/spark-confirmation'
const checkoutFailureUrl = 'https://musesessions.co/prisms'

window.onload = () => {
    console.log('prisms.js loaded.')

    try {
        const user = getLoggedInUser()
        if (user) {
            logUserActivity('VIEW_PRISMS', user.username, user)
        } else {
            logUserActivity('GUEST_VIEW_PRISMS')
        }
    } catch (error) {
        console.error('Error in Analytics:', error)
    }

    $('#spark-version').text('Spark version ')
    getAppRuntimeConstants()

    .then(response => {
        const { app_latest_version, spark_latest_version } = response
        $('#spark-version').text('Spark version ' + spark_latest_version)

        updateDownloadLinksWithVersion(app_latest_version, spark_latest_version)
    })

    const stripePriceIdLookup = {
        'starter-bundle-annual': 'price_1NmUqgJYJ1xBqV1YnN4elrpc,price_1NmUSjJYJ1xBqV1YrbEB9XT3',
        'creator-bundle-annual': 'price_1NmUpSJYJ1xBqV1YZ18NncGw,price_1NmUSjJYJ1xBqV1YrbEB9XT3',
        'pro-bundle-annual': 'price_1NmUobJYJ1xBqV1YcqODi1EH,price_1NmUSjJYJ1xBqV1YrbEB9XT3,price_1NmUWzJYJ1xBqV1YSNSztL4o',
        'starter-bundle-monthly': 'price_1NmUs2JYJ1xBqV1Yo4H0FoDI,price_1NmUSjJYJ1xBqV1YrbEB9XT3',
        'creator-bundle-monthly': 'price_1NmUtKJYJ1xBqV1Y5TKTvrBL,price_1NmUSjJYJ1xBqV1YrbEB9XT3',
        'pro-bundle-monthly': 'price_1NmUsfJYJ1xBqV1YHCk6Zb2q,price_1NmUSjJYJ1xBqV1YrbEB9XT3',
        'prisms-nexus': 'price_1NmUSjJYJ1xBqV1YrbEB9XT3',
        'prisms-4-alpha': 'price_1NmUfcJYJ1xBqV1Y573EYbeC',
        'prisms-4-omega': 'price_1NmUeqJYJ1xBqV1YWNWF5WiA',
        'prisms-3': 'price_1NmUd0JYJ1xBqV1YoGNy06Hd',
        'prisms-2': 'price_1NmUbCJYJ1xBqV1YwbCYXBa4',
        'prisms-1': 'price_1NmUYnJYJ1xBqV1YQUHbjOId',
    }

    const generateCheckoutLinkOrRedirect = async (priceId, promotionCode) => {
        const user = getLoggedInUser()
        const authToken = getAuthToken()
        if (user) {
            console.log('generateCheckoutLinkOrRedirect: is a logged in user. user=%O', user)
            // if logged in user, then simply get the checkout link from the api and 
            // go to the link.
            const checkoutLink = await fetchCheckoutLink(priceId, authToken, checkoutSuccessUrl, checkoutFailureUrl, promotionCode)
            return checkoutLink
        } else {
            // if not, then they go to the login page, with appropriate url params
            // to redirect them to the checkout link after they are done.
            const actionAfterLogin = btoa(JSON.stringify({
                op: 'stripeCheckout',
                priceId: priceId,
                successUrl: checkoutSuccessUrl,
                failureUrl: checkoutFailureUrl,
                promotionCode,
            }));
            const url = `login?actionAfterLogin=${actionAfterLogin}`
            console.log(`generateCheckoutLinkOrRedirect: is not a logged in user. redirecting to url "${url}".`)
            return url
        }
    }

    $(document).ready(function() {
        $('a').on('click', async function() {
            try {
                const buttonId = $(this).attr('id')

                console.log(`buttonId=${buttonId}`)

                // const promotionCode = (() => {
                //     if (! (buttonId||'').includes('prisms')) {
                //         return 'promo_1OEj1VJYJ1xBqV1Y7KIvbOQt' // BLACKFRIDAY
                //     } else {
                //         return null
                //     }
                // })()
                const promotionCode = null

                const stripePriceId = stripePriceIdLookup[buttonId] || null
                console.log(`buttonId=${buttonId} => stripePriceId=${stripePriceId}`)
                if (stripePriceId) {
                    const link = await generateCheckoutLinkOrRedirect(stripePriceId, promotionCode)
                    window.location.href = link
                }
            } catch(e) {
                alert(`There was an error during checkout. Please contact support. message: "${e.message}"`)
            }
        })
    })

    let isSending = false
    $('#edit-account-btn').on('click', (ev) => {
        ev.preventDefault()

        $('#error-text').css('display', 'none')

        function disableButton() {
            $('#edit-account-btn')
                .css('pointer-events', 'none')
                .css('opacity', '0.75')
            isSending = true
        }
        function enableButton() {
            $('#edit-account-btn')
                .css('pointer-events', 'auto')
                .css('opacity', '1')
            isSending = false
        }
        function removeButton() {
            $('#edit-account-btn').css('display', 'none')
        }

        const email = $('#email-signup').val()

        // disable button from further clicks
        disableButton()

        console.log(`POST`)
        if ((email||'').trim().length === 0) {
            alert(`Please specify an email.`)
            enableButton()
            return
        }

        $.ajax({
            method: 'POST',
            url: `${window.apiHost}/api/v1/requests/download-app-email`,
            data: JSON.stringify({ email: email }),
            dataType: 'json',
            contentType: 'application/json',
            error: response => {
                alert(`Sorry, there was an error while processing the request.`)
                enableButton()
            },
            success: response => {
                $('#success-message').css('display', 'block')
                $('#success-message > div').css('color', '#161616')
                removeButton()
            },
        })
    })
}
